import { Box, HStack } from '@chakra-ui/react'
import { ColumnDef } from '@tanstack/react-table'

import { Buttons } from '@/components/shared/buttons'
import { Table } from '@/components/shared/displayers/Table'
import { Call } from '@/services/backend/config/entities'

import { Chamados } from '..'

type Props = {
  data: Call[]
}

export default function Component({ data }: Props) {
  const columns: ColumnDef<(typeof data)[0]>[] = [
    {
      header: 'Nº',
      accessorKey: 'id',
    },
    {
      header: 'Sobre',
      accessorKey: 'about',
      cell: ({ row }) => {
        return (
          <Box>
            <Box fontSize="xs">
              {new Date(row.original.createdAt).toLocaleString()}
            </Box>
            <Box fontSize="sm">{row.original.description}</Box>
            <Chamados.Core.TempoAtendimento_ProgressBar
              createdAt={row.original.createdAt}
              status={row.original.status}
            />
          </Box>
        )
      },
    },
    {
      header: '',
      accessorKey: 'actions',
      enableSorting: false,
      cell: ({ row }) => (
        <HStack justifyContent="flex-end">
          <Buttons.Redirect
            aria-label="Detalhes"
            to={`/app/entity/chamados/${row.original.id}/detalhes`}
          />
        </HStack>
      ),
    },
  ]

  return (
    <Table
      data={data}
      columns={columns}
      initialSorting={[{ id: 'id', desc: false }]}
    />
  )
}
